export const modelPositions = [{
    name: "Exhibitions",
    offset: {
        desktop: [5.5, 0, 0],
        ipad: [-2, -3, 0],
        mobile: [2,3, 2]
    },
    target: {
        desktop: [0, 20, 0],
        ipad: [0, 20, 0],
        mobile: [0, 32.5, 0]
    },
    position: {
        desktop: [-23.451933501693464, 30.691232710497808, 16.878155943285346],
        ipad: [-1.5165737474766028, 27.568091910839836, 29.826202542987453],
        mobile: [-35.858940293476834, 43.44604524683583, 24.08132496360062],
    },
    translate: {
        desktop: [0,20,0],
        ipad: [0,20,0],
        mobile: [0,19.5,0],
    },
    azimuth: [5.336208793949821, 6.651236382905785],
    polar: [1.2164030351690311, 1.322608646189113],
    distance: {
        desktop: [18.808738520714638, 30.808738520714638],
        ipad: [18.808738520714638, 30.808738520714638],
        mobile: [35.55995643534055, 44.55995643534055]
    },
    content: {
        "align": "left",
        "title": "PresentationOS <br /> is the ultimate <br /> sales toolkit",
        "description": "<p>A cloud-based platform that enables interactive 3D, Augmented Reality (AR), and more.</p><ul><li>Showcase products in full 3D</li><li>Represent solutions in full-scale, true-to-life visualizations</li><li>Demonstrate value and drive results</li></ul>"
    },
    enabled: true
},
{
    name: "Remote",
    offset: {
        desktop: [-1, 0, 0],
        ipad: [-1, -1.5, 0],
        mobile: [0, -1, 0]
    },
    target: {
        desktop: [0, 2, 0],
        ipad: [0, 2, 0],
        mobile: [-1.5, 3.4019758563437614, 0]
    },
    position: {
        desktop: [1.3624583568276325, 2.3597913004848206, -12.464155322899195],
        ipad: [15.777786099798687, 2.479615905040098, -5.504795782808292],
        mobile: [0.6128523059471069, 3.4019758563437614, -20.157069069356837],
    },
    translate: {
        desktop: [0,0,0],
        ipad: [0,0,0],
        mobile: [0,-0.8,0],
    },
    azimuth: [1.7169250079484513, 3.0327148066804015],
    polar: [1.1077385117856309, 1.5421027603462467],
    distance: {
        desktop: [6.883146471821756, 12.54356051794507],
        ipad: [6.883146471821756, 16.717631305747695],
        mobile: [17.29372818671088, 20.29372818671088]
    },
    enabled: true,
    animated: false,
    content: {
        "align": "right",
        "title": "Make an impact in every remote presentation",
        "description": "<p>Interact with 3D or Augmented Reality to keep the audience engaged on video calls. Convey products, solutions, features, and benefits with sophisticated visualizations.</p>"
    },
},
{
    name: "Apollo",
    offset: {
        desktop: [0, 0, 0],
        ipad: [0, -2, 0],
        mobile: [0, 0, 0]
    },
    target: {
        desktop: [0, -25, 0],
        ipad: [0, -25, 0],
        mobile: [0, -25, 0]
    },
    position: {
        desktop: [-17.59846683454579, -6.812967815812037, -19.14040421621062],
        ipad: [-26.284789161999967, -2.4819147177944565, -9.484028771616279],
        mobile: [-35.48973379297004, -5.747292713934616, -59.75257639564684]
    }, 
    translate: {
        desktop: [0, -25.15, 2],
        ipad: [0, -25.15, 2],
        mobile: [-6, -30.15, 0],
    },
    azimuth: [-Infinity, Infinity],
    polar: [0.9092455534782166, 1.7509047181254704],
    distance: {
        desktop:[18.61244410831886, 31.72946042419554],
        ipad:[18.61244410831886, 35.843693275626884],
        mobile:[20.05006727159022, 72.05006727159022]
    },
    enabled: true,
    animated: true,
    content: {
        "align": "right",
        "title": "Explain complex solutions simply and effectively",
        "description": "<p>Showcase solutions from a macro or a micro perspective. Use interactive 3D models of products and solutions to convey benefits quickly and effectively.</p>"
    },
}
]